import classNames from 'classnames';
import React from 'react';
import Button from './Button';
import SVGIcon from './SVGIcon';
import * as styles from './Toast.module.scss';
import alertIcon from '../icons/non-prefilled/16x16/alert.svg';
import checkIcon from '../icons/non-prefilled/16x16/check.svg';
import clearIcon from '../icons/non-prefilled/16x16/clear.svg';
import type { ToastLevel } from '../ui/uiSlice';

const DISMISS_BUTTON_ICON_SIZE = parseInt(styles.dismissButtonIconSize, 10);

export interface ToastProps {
  icon?: React.ReactNode;
  level?: ToastLevel;
  message: React.ReactNode;
  onDismiss: () => void;
  primaryTo?: string;
  secondaryTo?: string;
  onPrimaryClick?: (options: { onDismiss: () => void }) => void;
  onSecondaryClick?: (options: { onDismiss: () => void }) => void;
  primaryTarget?: string;
  primaryText?: string;
  secondaryText?: string;
  title?: string;
  hideIcon?: boolean;
}

const LEVEL_ICONS: Record<ToastLevel, string> = {
  success: checkIcon,
  error: alertIcon,
  warning: alertIcon,
};

const Toast = ({
  icon,
  level,
  message,
  onDismiss,
  primaryTo,
  secondaryTo,
  onPrimaryClick,
  onSecondaryClick,
  primaryTarget,
  primaryText,
  secondaryText,
  title,
  hideIcon = false,
}: ToastProps) => (
  <div className={classNames(styles.toast, level && styles[level])}>
    {!hideIcon && (icon != null || level) && (
      <div className={styles.icon}>
        {icon == null || typeof icon === 'string' ? (
          <SVGIcon>{icon || (level && LEVEL_ICONS[level])}</SVGIcon>
        ) : (
          icon
        )}
      </div>
    )}
    <div className={styles.main}>
      {title && <div className={styles.title}>{title}</div>}
      {message}
      {(primaryText || secondaryText) && (
        <div className={styles.buttons}>
          {primaryText && (
            <Button
              variant="secondary"
              to={primaryTo}
              onClick={
                onPrimaryClick ? () => onPrimaryClick({ onDismiss }) : undefined
              }
              target={primaryTarget}
            >
              {primaryText}
            </Button>
          )}
          {secondaryText && (
            <Button
              variant="link"
              to={secondaryTo}
              onClick={
                onSecondaryClick
                  ? () => onSecondaryClick({ onDismiss })
                  : undefined
              }
            >
              <strong>{secondaryText}</strong>
            </Button>
          )}
        </div>
      )}
    </div>
    <div>
      <Button className={styles.dismissButton} onClick={onDismiss}>
        <SVGIcon size={DISMISS_BUTTON_ICON_SIZE}>{clearIcon}</SVGIcon>
      </Button>
    </div>
  </div>
);

export default Toast;
